import axios from 'axios';

export function filesize(size) {
	const i = Math.floor(Math.log(size) / Math.log(1024));
	return (
		(size / Math.pow(1024, i)).toFixed(2) * 1 +
		' ' +
		['B', 'kB', 'MB', 'GB', 'TB'][i]
	);
}

export function elementExists(selector) {
	return (
		typeof document.querySelector(selector) !== 'undefined' &&
		document.querySelector(selector) !== null
	);
}

export function getDefaultTimeout() {
	return 75000;
}

export function getUSStates() {
	return [
		'AL',
		'AK',
		'AZ',
		'AR',
		'CA',
		'CO',
		'CT',
		'DE',
		'DC',
		'FL',
		'GA',
		'HI',
		'ID',
		'IL',
		'IN',
		'IA',
		'KS',
		'KY',
		'LA',
		'ME',
		'MD',
		'MA',
		'MI',
		'MN',
		'MS',
		'MO',
		'MT',
		'NE',
		'NV',
		'NH',
		'NJ',
		'NM',
		'NY',
		'NC',
		'ND',
		'OH',
		'OK',
		'OR',
		'PA',
		'RI',
		'SC',
		'SD',
		'TN',
		'TX',
		'UT',
		'VT',
		'VA',
		'WA',
		'WV',
		'WI',
		'WY',
		'AS',
		'GU',
		'MP',
		'PR',
		'VI',
		'FM',
		'MH',
		'PW',
		'CZ',
		'PI',
		'TT'
	];
}

// Transforms key/value pairs to FormData() object
export function toFormData(values = {}, method = 'POST') {
	const formData = new FormData();
	for (const field of Object.keys(values)) {
		formData.append(field, values[field]);
	}

	// NOTE: When working with Laravel PUT/PATCH requests and FormData
	// you SHOULD send POST request and fake the PUT request like this.
	// More info: http://stackoverflow.com/q/50691938
	if (method.toUpperCase() === 'PUT') {
		formData.append('_method', 'PUT');
	}

	return formData;
}

export function validateEmail(emailValue) {
	let emailResult = 'valid';
	let atIndex = emailValue.indexOf('@');
	if (atIndex > -1) {
		let domainName = emailValue.substr(atIndex + 1);
		let emailName = emailValue.substr(0, atIndex);
		let domainNameLength = domainName.length;
		let emailNameLength = emailName.length;

		if (emailNameLength < 1 || emailNameLength > 64) {
			// emailName is too short/long
			if (emailNameLength < 1) {
				emailResult = 'Email Address is too short.';
			} else if (emailNameLength > 64) {
				emailResult = 'Email Address is too long';
			}
		} else if (domainNameLength < 1 || domainNameLength > 255) {
			// domainName is too short/long
			if (domainNameLength < 1) {
				emailResult = 'Email Address Domain Name is too short.';
			} else if (domainNameLength > 255) {
				emailResult = 'Email Address Domain Name is too long';
			}
		} else if (emailName[0] == '.' || emailName[emailNameLength - 1] == '.') {
			// emailName starts or ends with .
			if (emailName[0] == '.') {
				emailResult = 'Email Address cannot start with "."';
			} else if (emailName[emailNameLength - 1] == '.') {
				emailResult = 'Email Address cannot end with "."';
			}
		} else if (
			domainName[0] == '.' ||
			domainName[domainNameLength - 1] == '.'
		) {
			// domainName starts or ends with .
			if (domainName[0] == '.') {
				emailResult = 'Email Address Domain Name cannot start with "."';
			} else if (domainName[domainNameLength - 1] == '.') {
				emailResult = 'Email Address Domain Name cannot end with "."';
			}
		} else if (domainName.indexOf('.') < 0) {
			// no dot present in domainName
			emailResult = 'Email Address Domain Name is missing a "."';
		} else if (emailName.indexOf('..') > -1) {
			emailResult = 'Email Address cannot have two consequetive dots ".."';
			// emailName has two consequetive dots ..
		} else if (!(domainName.match(/^[A-Za-z0-9\-\.]+$/g) !== null)) {
			// invalid character in domainName
			emailResult =
				'Email Address has an invalid character in the Domain Name.';
		} else if (domainName.indexOf('..') > -1) {
			// domainName has two consequetive dots ..
			emailResult =
				'Email Address Domain Name cannot have two consequetive dots ".."';
		} else if (
			!(
				emailName
					.replace(/\\\\/gi, '')
					.match(/^[A-Za-z0-9!#%&`_=\\/$\'*+?^{}|~.\-]+$/gi) != null
			)
		) {
			// invalid character in emailName unless is quoted
			emailResult = 'Email Address has an invalid character.';
			// if(!preg_match('/^"(\\\\"|[^"])+"$/', str_replace('\\\\', '', emailName))) {

			// }
		} else {
		}
	} else {
		emailResult = 'Email Address does not have an "@" present.';
	}

	if (emailResult.trim() != 'valid') {
		emailResult = 'Invalid Email Address. ' + emailResult.trim();
	}

	return emailResult;
}

export function validateSpecialField(
	fieldName,
	fieldLabel,
	fieldValue,
	bIsRequired
) {
	let result = []; // initialize result as array to allow for future expansion

	if (bIsRequired && fieldValue == '') {
		result['error_message'] = fieldLabel + ' cannot be blank.';
	} else if (fieldName == 'email' || fieldName == 'email_address') {
		let emailValidateResult = validateEmail(fieldValue);
		if (emailValidateResult != 'valid') {
			result['error_message'] = emailValidateResult;
		}
	} else if (
		fieldName === 'new_password' ||
		fieldName === 'new_password_confirm'
	) {
		const minLength = 14;
		if (fieldValue.length < minLength) {
			result['error_message'] =
				fieldLabel +
				' is too short. ' +
				fieldLabel +
				' must be at least ' +
				minLength +
				' characters long.';
		}
	} else if (fieldName == 'rx_number') {
		if (isNaN(fieldValue)) {
			result['error_message'] =
				fieldLabel + ' must only consist of only numbers.';
		} else if (fieldValue.length < 7 || fieldValue.length > 9) {
			result['error_message'] =
				fieldLabel + ' must be between 7 and 9 numbers long.';
		}
	} else if (fieldName == 'ssn') {
		if (isNaN(fieldValue)) {
			result['error_message'] =
				fieldLabel + ' must only consist of only numbers.';
		} else if (fieldValue.length != 9) {
			result['error_message'] = fieldLabel + ' must be 9 numbers long.';
		}
	} else if (fieldName == 'birth_month') {
		if (fieldValue.length != 2) {
			result['error_message'] = fieldLabel + ' is invalid length. (FORMAT: MM)';
		} else if (isNaN(fieldValue)) {
			result['error_message'] = fieldLabel + ' must be numeric. (FORMAT: MM)';
		} else if (parseInt(fieldValue) > 12 || parseInt(fieldValue) < 1) {
			result['error_message'] = fieldLabel + ' is invalid. (FORMAT: MM)';
		}
	} else if (fieldName == 'birth_day') {
		if (fieldValue.length != 2) {
			result['error_message'] = fieldLabel + ' is invalid length. (FORMAT: DD)';
		} else if (isNaN(fieldValue)) {
			result['error_message'] = fieldLabel + ' must be numeric. (FORMAT: DD)';
		} else if (parseInt(fieldValue) < 1 || parseInt(fieldValue) > 31) {
			result['error_message'] = fieldLabel + ' is invalid. (FORMAT: DD)';
		}
	} else if (fieldName == 'birth_year') {
		let currentYear = parseInt(new Date().getFullYear());
		if (fieldValue.length != 4) {
			result['error_message'] =
				fieldLabel + ' is invalid length. (FORMAT: YYYY)';
		} else if (isNaN(fieldValue)) {
			result['error_message'] = fieldLabel + ' must be numeric. (FORMAT: YYYY)';
		} else if (parseInt(fieldValue) < 1900) {
			result['error_message'] = fieldLabel + ' is invalid. (FORMAT: YYYY)';
		} else if (parseInt(fieldValue) > currentYear) {
			result['error_message'] =
				fieldLabel + ' cannot be a future date. (FORMAT: YYYY)';
		}
	} else if (fieldName == 'cell_phone') {
		if (
			!(fieldValue.match(/^[0-9]+$/g) !== null) ||
			fieldValue == '0000000000' ||
			fieldValue == '1111111111'
		) {
			result['error_message'] =
				fieldLabel + ' must only contain numbers. (Correct Format: ##########)';
		} else if (fieldValue.length < 10) {
			result['error_message'] =
				fieldLabel + ' must be 10 digits. (Correct Format: ##########)';
		}
	} else if (
		fieldName == 'street_address_line_1' ||
		fieldName == 'shipping_address_line_1'
	) {
		if (!isNaN(fieldValue)) {
			result['error_message'] = fieldLabel + ' must be an actual address.';
		}
	} else if (
		fieldName == 'street_address_line_2' ||
		fieldName == 'shipping_address_line_2'
	) {
	} else if (
		fieldName == 'street_address_city' ||
		fieldName == 'shipping_address_city'
	) {
		if (!isNaN(fieldValue)) {
			result['error_message'] = fieldLabel + ' must be an actual city.';
		}
	} else if (
		fieldName == 'street_address_state' ||
		fieldName == 'shipping_address_state'
	) {
		const arrStates = getUSStates();
		if (arrStates.includes(fieldValue) === false) {
			result['error_message'] = fieldLabel + ' is not a valid state.';
		}
	} else if (
		fieldName == 'street_address_postal_code' ||
		fieldName == 'shipping_address_postal_code' ||
		fieldName == 'cc_billing_zip'
	) {
		if (!fieldValue.match(/^[0-9]{5}(?:-[0-9]{4})?$/)) {
			result['error_message'] =
				fieldLabel + ' is invalid. (Correct Format: ##### or #####-####)';
		}
	} else if (
		fieldName == 'street_address_unit' ||
		fieldName == 'shipping_address_unit'
	) {
	} else if (fieldName == 'cc_card_number') {
		if (!(fieldValue.match(/^[0-9]+$/g) !== null)) {
			result['error_message'] = 'Credit Card must contain only numbers.';
		} else if (fieldValue.trim().length != 16) {
			result['error_message'] = 'Credit Card must be 16 digits long.';
		}
	} else if (fieldName == 'cc_expiration_date') {
		if (!fieldValue.match(/^(0|1)[0-9]\/[0-9]{4}$/)) {
			result['error_message'] =
				'Invalid Expiration Date. (Correct Format: ##/####)';
		} else {
			let arrCcExpDate = fieldValue.split('/');
			if (arrCcExpDate.length == 2) {
				if (arrCcExpDate[0] == '00' || parseInt(arrCcExpDate[0]) > 12) {
					result['error_message'] =
						'Invalid Expiration Date Month. (Valid Months: 01 through 12)';
				} else {
					let dtMonth = new Date().getMonth() + 1;
					let dtYear = new Date().getFullYear();
					if (parseInt(arrCcExpDate[1]) < dtYear) {
						result['error_message'] =
							'Invalid Expiration Date Year. Please try again.';
					} else if (
						parseInt(arrCcExpDate[1]) == dtYear &&
						parseInt(arrCcExpDate[0]) < dtMonth
					) {
						result['error_message'] =
							'Invalid Expiration Date Month. Please try again.';
					}
				}
			} else {
				result['error_message'] =
					'There is an error with your Expiration Date. Please try again.';
			}
		}
	} else if (fieldName == 'cc_cvv_code') {
		if (!(fieldValue.match(/^[0-9]+$/g) !== null)) {
			result['error_message'] = 'Security Code must contain only numbers.';
		} else if (fieldValue.trim().length < 3 || fieldValue.trim().length > 4) {
			result['error_message'] = 'Security Code must be between 3 and 4 digits.';
		}
	}

	if (
		typeof result['error_message'] !== 'undefined' &&
		result['error_message'].trim() != ''
	) {
		result = result['error_message'];
	} else {
		result = '';
	}

	return result;
}

export function getCsrfToken(tagName = 'csrf-token') {
	return document.querySelector(`meta[name="${tagName}"]`).content;
}

export function setCsrfToken(token, tagName = 'csrf-token') {
	document.querySelector(`meta[name="${tagName}"]`).content = token;
}

export async function refreshToken() {
	const url = route('refresh-token');
	if (!url) {
		throw new Error('No route found for refresh-token');
	}

	const res = await fetch(url, {
		headers: {
			'Content-Type': 'application/json'
		}
	});
	const json = await res.json();
	if (!json) throw new Error('No response from server');
	if (!json?.token) throw new Error('No token in response');
	setCsrfToken(json.token);
}

/**
 *makes an async call to the provided url with the provided options
 * and returns the data from the response, handling errors, status messages and csrf tokens
 * using the provided callbacks
 * @param {
 *  routeName: string,
 *  options?: object,
 *  setMessageCallback?: (statusMessage: string) => void
 *  method?: string
 * } params
 * @returns {any} data
 */
export async function useAPICall({
	routeName,
	options = {},
	params = {},
	onValidationErrorCallback = messageBag => {
		const { errors = {}, error = {} } = messageBag;
		const errorList = Object.keys(errors).length
			? Object.keys(errors).map(key => `${errors[key]}`)
			: [];
		const errorMessage =
			'Failed due to the following errors:\n\n' + errorList.length
				? errorList.join('\n')
				: error?.errorMessage +
					'\n\nPlease correct the errors and try again. If this problem persists, please contact support';
		console.error(errorMessage);
		alert(errorMessage);
	},
	setMessageCallback = () => {},
	method = 'GET',
	onErrorCallback = error => {
		const errorCode = error?.errorCode || 0;
		const seed = Math.random().toString(36).substring(2, 7).toUpperCase();
		// convert all vowels to consonants
		seed.replaceAll(/[a]/gi, 'B');
		seed.replaceAll(/[e]/gi, 'C');
		seed.replaceAll(/[i]/gi, 'D');
		seed.replaceAll(/[o]/gi, 'F');
		seed.replaceAll(/[u]/gi, 'G');
		seed.replaceAll(/[y]/gi, 'H');
		// no ambiguous characters
		seed.replaceAll(/[0]/g, '2');
		seed.replaceAll(/[1]/g, '7');
		seed.replaceAll(/[3]/gi, '4');
		seed.replaceAll(/[5]/g, '6');
		seed.replaceAll(/[L]/gi, 'G');
		seed.replaceAll(/[S]/gi, 'T');
		seed.replaceAll(/[V]/gi, 'W');
		const traceId = seed.substring(0, 3) + '-' + seed.substring(3);
		const unknownError = !error?.errorMessage && errorCode?.errorCode !== 0;
		const errorMessage = !unknownError
			? `The server returned the following error\n\nError code: ${error.errorCode}\nMessage: ${error.errorMessage}\n\nIf this problem persists, please contact support`
			: 'An unknown error has occurred. Please try again later. If the problem persists, please contact support and provide the following trace ID: ' +
				traceId;
		console.error(error);
		!unknownError
			? alert(errorMessage)
			: reportUnknownError(error, routeName, options);
	},
	tokenRefreshed = false
}) {
	try {
		const url =
			method === 'GET' ? route(routeName, options) : route(routeName, params);
		if (method !== 'GET') {
			options._token = document.querySelector(
				'meta[name="csrf-token"]'
			).content;
		}
		const response = await fetch(url, {
			method,
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: method === 'GET' ? undefined : JSON.stringify(options)
		});
		if (response.status === 419) {
			if (!tokenRefreshed) {
				await refreshToken();
				useAPICall({
					routeName,
					options,
					onErrorCallback,
					onValidationErrorCallback,
					setMessageCallback,
					method,
					tokenRefreshed: true
				});
			} else {
				// This should be a rare instance
				alert(
					'Your session has expired. We will reload the page for you. Please try again. If this problem persists, please contact support.'
				);
				window.location.reload();
			}
			return;
		}
		const json = await response.json();
		if (response.status === 422 && json?.errors !== undefined) {
			onValidationErrorCallback(json);
		} else {
			if (
				json?.data === undefined ||
				json?.csrfToken === undefined ||
				json?.statusMessage === undefined ||
				json?.error === undefined ||
				json?.error?.errorCode === undefined ||
				json?.error?.errorMessage === undefined
			)
				throw new Error(
					'Invalid response from server: ' + JSON.stringify(json)
				);
			if (json.csrfToken)
				document.querySelector('meta[name="csrf-token"]').content =
					json.csrfToken;
			setMessageCallback(json.statusMessage);
			if (json.error.errorCode === 0)
				return { ...json.data, csrfToken: json.csrfToken };
			return onErrorCallback(json.error);
		}
	} catch (error) {
		return onErrorCallback(error);
	}
}

export async function reportUnknownError(error, routeName = '', options = {}) {
	const traceId = Math.random().toString(36).substring(2, 7);
	const send = confirm(
		'An unexpected error has occurred:\n' +
			(error?.message || 'no error message specified') +
			'\nWould you like to help us improve by reporting it to the server?\n\nNote: This will also allow us to see the original request that caused the error'
	);
	if (!send) return;
	try {
		const res = await fetch(route('report-error'), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			body: JSON.stringify({
				error: error.toString(),
				route: routeName,
				options: options,
				traceId: traceId
			})
		});
		if (!res.ok) throw new Error('Failed to report error');
		alert(
			'Thank you for helping us improve! If this particular issue persists, the following trace ID may help us find details regarding your specific issue: ' +
				traceId
		);
	} catch (error) {
		alert(
			'An error occurred while trying to report to the server. This may be a result of the original error. Please contact support if this problem persists.'
		);
	}
}
